import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { NoResource } from "./NoResource";

export const NoContent: FC = () => {
  const { t } = useTranslation("catalog");

  return <NoResource headerText={t("nothingFoundMessage")} />;
};
